import axiosClient from './axiosClient';

const adminDispatchService = {
    getAll: async (params = {}) => {
        const response = await axiosClient.get('/admin/delivery', { params });
        return response.data;
    },
    getById: async (id) => {
        const response = await axiosClient.get(`/admin/delivery/${id}`);
        return response.data;
    }
};

export default adminDispatchService;
